export default __webpack_public_path__ + "static/medium-image-completely-2-d0ba5493259cec66052f4d31006b7098.png";